<script setup lang="ts">
import background from '~/assets/images/backgrounds/levels.jpg';

const { t } = useI18n();
</script>

<template>
  <section class="relative bg-black p-section overflow-hidden">
    <div class="page-image-preview !h-auto !bottom-auto lg:!bottom-0">
      <NuxtImg
        class="block w-full h-auto"
        :src="background"
        :alt="t('preview_alt')"
        sizes="xs:100vw sm:100vw md:100vw lg:100vw xl:100vw xxl:100vw"
        format="avif"
        width="1000"
        height="1000"
        preload
      />
      <div class="page-overflow-8 lg:page-overflow-7 section-bottom-shadow" />
    </div>

    <div class="lg:container pb-4 md:pb-20 z-1">
      <div class="pt-20">
        <div class="relative z-1">
          <BasePulsedLogo class="mx-auto mt-6 sm:mt-8 md:mt-12 mb-2 md:mb-4" />

          <h1
            class="text-900 font-bold text-3xl md:text-6xl mb-9 md:mb-12 mt-0 text-center"
          >
            {{ t('title') }}
          </h1>
          <p
            class="text-700 text-sm md:text-xl mx-auto text-justify md:text-center leading-6 mb-6 md:px-6 lg:px-8"
            style="white-space: pre-wrap; max-width: 1400px"
          >
            {{ t('description.0') }}
          </p>
          <p
            class="text-700 text-sm md:text-xl mx-auto text-justify md:text-center leading-6 mb-8 md:mb-9 md:px-6 lg:px-8"
            style="white-space: pre-wrap; max-width: 1400px"
          >
            {{ t('description.1') }}
          </p>
        </div>
      </div>

      <div
        class="grid grid-cols-1 lg:grid-cols-3 pb-6 relative z-1 gap-4 md:gap-3 lg:gap-4"
      >
        <Card
          data-show-on-visible
          class="shadow-2 neon-border"
          :pt="{ body: 'h-full', content: 'h-full flex flex-col' }"
        >
          <template #content>
            <p class="text-900 text-center text-xl font-bold my-0">
              {{ t('levels.0.title') }}
            </p>
            <p
              class="text-800 flex-grow-1 py-3 lg:py-4 mt-0 mb-0 leading-6 text-sm md:text-lg"
            >
              {{ t('levels.0.description') }}
            </p>
            <hr
              class="mb-3 mt-auto mx-0 border-solid border-0 border-t border-white"
            />
            <Button
              as="nuxt-link"
              to="/game/settings"
              :label="t('levels.0.action')"
              severity="success"
              class="p-3 w-full"
            />
          </template>
        </Card>

        <Card
          data-show-on-visible='{ "delay": 150, "noDelayOnMobile": 992 }'
          class="shadow-2 neon-border"
          :pt="{ body: 'h-full', content: 'h-full flex flex-col' }"
        >
          <template #content>
            <p class="text-900 text-center text-xl font-bold my-0">
              {{ t('levels.1.title') }}
            </p>
            <p
              class="text-800 flex-grow-1 py-3 lg:py-4 mt-0 mb-0 leading-6 text-sm md:text-lg"
            >
              {{ t('levels.1.description') }}
            </p>
            <hr
              class="mb-3 mt-auto mx-0 border-solid border-0 border-t border-white"
            />
            <Button
              as="nuxt-link"
              to="/game/settings"
              :label="t('levels.1.action')"
              severity="warn"
              class="p-3 w-full"
            />
          </template>
        </Card>

        <Card
          data-show-on-visible='{ "delay": 300, "noDelayOnMobile": 992 }'
          class="shadow-2 neon-border"
          :pt="{ body: 'h-full', content: 'h-full flex flex-col' }"
        >
          <template #content>
            <p class="text-900 text-center text-xl font-bold my-0">
              {{ t('levels.2.title') }}
            </p>
            <p
              class="text-800 flex-grow-1 py-3 lg:py-4 mt-0 mb-0 leading-6 text-sm md:text-lg"
            >
              {{ t('levels.2.description') }}
            </p>
            <hr
              class="mb-3 mt-auto mx-0 border-solid border-0 border-t border-white"
            />
            <Button
              as="nuxt-link"
              to="/game/settings"
              :label="t('levels.2.action')"
              severity="danger"
              class="p-3 w-full"
            />
          </template>
        </Card>
      </div>
    </div>
  </section>
</template>

<i18n>
en:
  preview_alt: About sex tasks game
  title: About sex tasks game
  description:
    - An erotic game for you and your partner that will help diversify your sex life, bring new sensations and
      experiments into it, and give you unforgettable pleasure!
    - >
      While playing, everyone gets a task of erotic content with a detailed description of what needs to be done. Each
      player performs a task and passes the move to partner. There are tasks of different levels: from conversational
      and light eroticism to frank sex with various experiments - it all depends on you, what you choose.
  levels:
    - title: Warm up
      description: Preparatory caresses, the beginning of a romantic night. You relax, tune in to playfulness. Most tasks can
        be completed without removing your underwear.
      action: Start
    - title: Game
      description: Frankness is growing, emotions are seething. You have already got rid of your underwear and moved on to
        more serious fun. There is a red level and finish ahead, but it's already hard not to get carried away...
      action: Play
    - title: Sex
      description: Emotions are boiling, an explosion is close, you don't want to look at the screen at all. Each task is
        created only to give you even more pleasure from what is happening.
      action: Dive
  logo_alt: Sex Play website logo

ru:
  preview_alt: Об эротических фантах и сексуальных заданиях
  title: О секс фантах
  description:
    - Эротическая игра для вас и вашего партнера, которая разнообразит вашу сексуальную жизнь, принесет в нее новые
      эксперименты и подарит незабываемое наслаждение!
    - >
      Каждому достается задание эротического содержания с подробным описанием. Каждый выполняет задание и передает ход
      своему партнеру. Фанты разного уровня: от разговорных и легкой эротики до секса с различными экспериментами.
  levels:
    - title: Разогрев
      description: Подготовительные ласки, начало романтической ночи. Вы расслабляетесь, настраиваетесь на игривый лад.
      action: Начать
    - title: Игра
      description: Откровенность нарастает, эмоции бурлят. Вы уже перешли к более серьезным забавам. Но впереди все еще
        горячее, уже сложно удержаться...
      action: Играть
    - title: Секс
      description: Страсть кипит, вы полны возбуждения! Каждое задание создано лишь с целью подарить вам еще большее
        удовольствия от происходящего.
      action: Погрузиться
  logo_alt: Логотип сайта Sex Play

de:
  preview_alt: Über erotische Einbußen und sexuelle Aufgaben
  title: Über den Verzicht auf Sex
  description:
    - Ein erotisches Spiel für Sie und Ihren Partner, das Ihr Sexualleben abwechslungsreicher macht, neue Experimente
      mit sich bringt und Ihnen unvergessliches Vergnügen bereitet!
    - 'Jeder bekommt eine erotische Aufgabe mit ausführlicher Beschreibung. Jeder erledigt die Aufgabe und gibt den
      Umzug an seinen Partner weiter. Verführungen auf verschiedenen Ebenen: von Konversation und leichter Erotik bis
      hin zu Sex mit verschiedenen Experimenten.'
  levels:
    - title: Aufwärmen
      description: Vorbereitende Liebkosungen, der Beginn einer romantischen Nacht. Sie entspannen sich und kommen in
        spielerische Stimmung.
      action: Beginnen
    - title: Spiel
      description: Die Offenheit wächst, die Emotionen kochen hoch. Sie sind bereits zu ernsterem Spaß übergegangen. Aber es
        wird noch heißer, es ist schwer zu widerstehen ...
      action: Spielen
    - title: Sex
      description: Die Leidenschaft brodelt, du bist voller Aufregung! Jede Aufgabe wird mit dem einzigen Zweck erstellt,
        Ihnen noch mehr Freude am Geschehen zu bereiten.
      action: Tauchen Sie ein
  logo_alt: 'Site-Logo #9198622493010009#'

es:
  preview_alt: Sobre pérdidas eróticas y tareas sexuales.
  title: Sobre las pérdidas sexuales
  description:
    - ¡Un juego erótico para ti y tu pareja que diversificará tu vida sexual, te traerá nuevos experimentos y te
      brindará un placer inolvidable!
    - 'Cada uno recibe una tarea erótica con una descripción detallada. Todos completan la tarea y pasan el movimiento a
      su compañero. Pérdidas de diferentes niveles: desde erótica conversacional y ligera hasta sexo con diversos
      experimentos.'
  levels:
    - title: Calentando
      description: Caricias preparatorias, el comienzo de una noche romántica. Te relajas y te pones de buen humor.
      action: Comenzar
    - title: Juego
      description: La franqueza crece, las emociones hierven. Ya has pasado a una diversión más seria. Pero las cosas están
        aún más calientes por delante, es difícil resistirse...
      action: Jugar
    - title: Sexo
      description: ¡La pasión está hirviendo, estás lleno de emoción! Cada tarea se crea con el único propósito de brindarte
        aún más placer de lo que está sucediendo.
      action: Sumérgete
  logo_alt: Logotipo del sitio web _4341132487900572_

fr:
  preview_alt: À propos des forfaits érotiques et des tâches sexuelles
  title: À propos des forfaits sexuels
  description:
    - Un jeu érotique pour vous et votre partenaire qui diversifiera votre vie sexuelle, y apportera de nouvelles
      expériences et vous procurera un plaisir inoubliable !
    - "Chacun reçoit une tâche érotique avec une description détaillée. Chacun termine la tâche et transmet le mouvement
      à son partenaire. Des forfaits à différents niveaux : de l'érotisme conversationnel et léger au sexe avec diverses
      expériences."
  levels:
    - title: Échauffement
      description: Caresses préparatoires, début d'une nuit romantique. Vous vous détendez et entrez dans une ambiance ludique.
      action: Commencer
    - title: Jeu
      description: La franchise grandit, les émotions bouillonnent. Vous êtes déjà passé à un plaisir plus sérieux. Mais la
        situation est encore plus chaude, il est difficile de résister...
      action: Jouer
    - title: Sexe
      description: La passion bouillonne, vous êtes plein d'enthousiasme ! Chaque tâche est créée dans le seul but de vous
        donner encore plus de plaisir de ce qui se passe.
      action: Plongez-vous
  logo_alt: Logo du site Web _5845609350277572_
</i18n>
